import { render } from "./wrongQuestion.vue?vue&type=template&id=0cab085c&scoped=true"
import script from "./wrongQuestion.vue?vue&type=script&lang=js"
export * from "./wrongQuestion.vue?vue&type=script&lang=js"

import "./wrongQuestion.vue?vue&type=style&index=0&id=0cab085c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cab085c"]])

export default __exports__